import Input, { InputProps } from 'ui/components/atoms/Input';
// import WarningIcon from '../Icons/WarningIcon';

export const InputField = ({
  label,
  name,
  placeholder,
  value,
  containerClassName = 'mt-4',
  disabled,
  error,
  showMessageError = false,
  iconPosition,
  inputClassName,
  ...props
}: InputProps) => (
  <div>
    <Input
      label={label}
      name={name}
      placeholder={placeholder}
      value={value}
      containerClassName={containerClassName}
      labelClassName="text-[13px] block leading-[18px] text-reliableBlack70 font-medium"
      inputClassName={`${inputClassName} text-[16px] leading-[22px] !max-h-[52px] py-[15px] rounded-none disabled:opacity-100 disabled:!bg-reliableBlack10 disabled:!text-reliableBlack50`}
      size="large"
      disabled={disabled}
      showMessageError={showMessageError}
      error={error}
      // icon={error && <WarningIcon />}
      iconPosition={iconPosition}
      iconClassName={`bg-reliableBlack3 ${error ? 'border-supportiveRed' : ''}`}
      {...props}
    />
    {error && <p className="text-supportiveRed text-xs leading-[20px] mt-0.5">{error}</p>}
  </div>
);

export default InputField;
